import React, {useEffect} from "react";
import {observer} from "mobx-react-lite";
import clubStore from "../../../storage/ClubStore";
import TeamList from "../TeamList";
import {useLocation} from 'react-router-dom'

const Teams = () => {
    const location = useLocation();
    useEffect(() => {
        clubStore.getTeamsTrainer();
        console.log('Teams MOUNT', new Date());
        return () => console.log('Teams UNMOUNT');
    }, [location.pathname]);
    return (
        <TeamList role={"TRN"}/>
    );
}

export default observer(Teams);